module.exports = __webpack_public_path__ + "static/media/mute.87baa649.svg";